/* eslint-disable */

import Vue from 'vue'
import VueResource from 'vue-resource'
import authService from '../utils/authService'
import Utils from '../utils/utils'
import store from '../store'
import {LOG_OUT, SHOW_TOAST} from '../store/types'
/* eslint-enable */

Vue.use(VueResource)

// HTTP相关
// Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true
// Vue.http.headers = {
//   'Content-Type': 'Content-Type: application/json'
// }
Vue.http.options.emulateJSON = true

/* 封装请求头,把token 注入到http 头部 */
Vue.http.interceptors.push((request, next) => {
  // 这里对请求体进行处理
  request.headers = request.headers || {}
  if (authService.getCookie('token')) {
    request.headers.set('token', authService.getCookie('token'))
  }
  next((response) => {
    // 这里可以对响应的结果进行处理
    console.debug(response)
    if (response.body.code === '0000002' || response.body.code === '0000001') {
      store.dispatch(LOG_OUT)
      var url = 'https://passport.lenovo.com/glbwebauthnv6/gateway?lenovoid.action=uilogout&lenovoid.realm=seservice.PDGuide.lenovo.com&display=small&bootReg=&lang=en_us&lenovoid.cb=http%3a%2f%2f' +
        window.location.host +
        '%2f' +
        store.state.global.code +
        '%2flogin'      // window.parent.location.reload() // 针对嵌入iframe cookie失效
      var proxyUrl = 'https://passport.lenovo.com/glbwebauthnv6/gateway?lenovoid.action=uilogout&lenovoid.realm=seservice.PDGuide.lenovo.com&display=small&bootReg=&lang=en_us&lenovoid.cb=https%3a%2f%2fseservice.lenovo.com%2fstatic_file%2fdownload2%2flogin.html' + '%3f' + 'host' + '%3d' +
        window.location.host +
        //          '%2f' +
        //          this.$store.state.global.code +
        '%2flogin'
      window.location.href = (process.env.NODE_ENV !== 'development') ? url : proxyUrl
    }
    if (!response.ok) {
      // store.dispatch(SHOW_TOAST, 'system error')  // 不用写处理异常的代码
    }
  })
})

/**
 * 登录
 * @param username
 * @param password
 * @returns {*}
 */
export function login (username, password) {
  let para = {
    username,
    password
  }
  return Vue.http.post(Utils.paths.login, para)
}
export function readToken (wust) {
  return Vue.http.post(Utils.paths.readToken, {wust: wust})
}
export function authValidate (wust) {
  return Vue.http.post(Utils.paths.authValidate)
}
export function createUser (data) {
  console.log(data)
  return Vue.http.post(Utils.paths.createUser, {users: data}, {emulateJSON: false})
}
export function userSearch (data) {
  return Vue.http.post(Utils.paths.userSearch, data, {emulateJSON: false})
}
export function userHotUpdate (data) {
  return Vue.http.post(Utils.paths.userHotUpdate, data, {emulateJSON: false})
}
export function updateSqlite () {
  return Vue.http.get(Utils.paths.PDTree.updateSqlite)
}
export function getCurrentUserDataById (id) {
  return Vue.http.get(Utils.paths.getCurrentUserDataById + '?lenovoID=' + id)
}
/* 首页请求 start */
export function homePageNewsDetail (id) {
  let para = {
    pictorialId: id
  }
  return Vue.http.post(Utils.paths.homePageNewsDetail, para)
}
export function queryDatabaseInfo () {
  return Vue.http.get(Utils.paths.queryDatabaseInfo)
}
export function queryLangOpt () {
  return Vue.http.get(Utils.paths.queryLangOpt)
}
export function queryRegionOpt () {
  return Vue.http.get(Utils.paths.queryRegionOpt)
}
export function getProductSecurityInfo () {
  return Vue.http.get(Utils.paths.getProductSecurityInfo)
}
/* Data Platform */
export function lowAndHighValueParts () {
  return Vue.http.get(Utils.paths.DP.lowAndHighValueParts)
}
export function PDCode2Symptom () {
  return Vue.http.get(Utils.paths.DP.PDCode2Symptom)
}
export function PDCode2SymptomI1 (pdCode) {
  return Vue.http.get(Utils.paths.DP.PDCode2SymptomI1 + '?pd_code=' + pdCode)
}
export function MT2SubSeriesI1 (MT) {
  return Vue.http.get(Utils.paths.DP.MT2SubSeriesI1 + '?MT=' + MT)
}
export function symptomOpt () {
  return Vue.http.get(Utils.paths.DP.symptomOpt)
}
export function productSubseriesOpt () {
  return Vue.http.get(Utils.paths.DP.productSubseriesOpt)
}
export function fieldsOpt (table, field, database, product) {
  return Vue.http.get(Utils.paths.DP.productSubseriesOpt + '?table=' + table + '&field=' + field + '&database=' + database + '&product=' + product)
}
/* 上传图片 */
export function uploadImg (file) {
  return Vue.http.post(Utils.paths.imgUploadUrl, file)
}

export function homePageNavList () {
  return Vue.http.get(Utils.paths.homePageNavList)
}

export function homePagePanelTop () {
  return Vue.http.get(Utils.paths.homePagePanelTop)
}

export function homePagePanelTopRefresh () {
  return Vue.http.get(Utils.paths.homePagePanelTopRefresh)
}

export function homePagePanelBottom () {
  return Vue.http.get(Utils.paths.homePagePanelBottom)
}

export function homePagePanelBottomRefresh () {
  return Vue.http.get(Utils.paths.homePagePanelBottomRefresh)
}
/* 首页请求 end */

// , {emulateJSON: false}, {headers: {'ContentType': 'application/json'}}
/* 公共接口 */
/**
 * 根据用户加载组织机构
 * @param userId
 * @return
 */
export function loadOrganTree (userId) {
  let par = userId ? {userId} : {}
  return Vue.http.post(Utils.paths.common.loadOrganTree, par)
}
/**
 * 根据组织机构id查询子属组织机构
 * @param userId
 * @return
 */
export function querySubTreeById (id, exclusionOrgTypes) {
  let par = {id}
  if (exclusionOrgTypes === 'exclusionOrgTypes') { par.exclusionOrgTypes = '2,3,4,5,7,9' }
  return Vue.http.post(Utils.paths.common.querySubTreeById, par)
}
export function loadOrganAllTreeByOrganId (organId) {
  let par = {organId}
  return Vue.http.post(Utils.paths.common.loadOrganAllTreeByOrganId, par)
}
/**
 * 根据关键字查询组织机构
 * @param keywords
 * @return
 */
export function queryTreeByKey (keywords, exclusionOrgTypes) {
  let par = {keywords}
  if (exclusionOrgTypes === 'exclusionOrgTypes') { par.exclusionOrgTypes = '2,3,4,5,7,9' }
  return Vue.http.post(Utils.paths.common.queryTreeByKey, par)
}

/* 公共接口 查询组织机构员工(不分页) */
export function queryUserList (organId, userName) {
  let par = {
    params: {
      organId,
      userName
    }
  }
  return Vue.http.get(Utils.paths.common.queryUserList, par)
}
/* 公共接口 获取服务处分组信息 */
export function loadServiceManagerTree (organId, userName) {
  let par = {organId, userName}
  return Vue.http.post(Utils.paths.common.loadServiceManagerTree, par)
}
/* 公共接口 根据服务处分组获取员工列表 */
export function queryUserByGroupList (groupId, userName) {
  let par = {
    params: {
      groupId,
      userName
    }
  }
  return Vue.http.get(Utils.paths.common.queryUserByGroupList, par)
}
/* 公共接口 */
export * from './modules/RequestPDTree.js'
export * from './modules/RequestPI.js'
export * from './modules/RequestTips.js'



// WEBPACK FOOTER //
// ./src/api/index.js